import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { BingoConfigProviderService, FeaturesClientConfig, ScheduleService } from '@frontend/bingo/frontend-lib/core';
import { LoadingIndicatorService, SessionStoreService, UserLoginEvent, UserService } from '@frontend/vanilla/core';
import { filter } from 'rxjs/operators';

import { LoginService } from '../../../services/login-Service';
import { SessionPackageService } from '../../../services/session-package.service';
import { PackageItemComponent } from '../package-item/package-item.component';
import { PackagesFilterComponent } from '../packages-filter/packages-filter.component';

@Component({
    selector: 'bg-bingo-packages-container',
    templateUrl: './packages-container.component.html',
    imports: [PackagesFilterComponent, PackageItemComponent],
})
export class PackagesContainerComponent implements OnInit, OnDestroy {
    selectedFilterItem: any;
    content: any = [];
    gameFeatureArray: any[] = [];
    packagesAvailable: boolean = false;
    packagesLoading: boolean = true;
    clientConfig: any;
    featuresConfig: FeaturesClientConfig;
    _loadingIndicator: any;
    packageFilterItems: any[] = [];
    deepLinkedPackageId: any;
    filteredPackagesAvailable: boolean = false;
    @ViewChildren('packages') private packages: QueryList<PackageItemComponent>;

    // packageFilterItems = [{key: '90 Ball', value:'90', type: 'bingo_type'},{key: '75 Ball', value:'75', type: 'bingo_type'}, {key: '50 Ball', value:'50', type: 'bingo_type'}, {key: 'Feature', type: 'features'}];
    // packagesfilterMap = {"90 Ball" : {'key': '90 Ball', 'value':'90', 'type': 'bingo_type'},"75 Ball" :{'key': '75 Ball', 'value':'75', 'type': 'bingo_type'}, "50 Ball" :{'key': '50 Ball', 'value':'50', 'type': 'bingo_type'}, "Feature" : {'key': 'Feature', 'type': 'features'}};
    constructor(
        private sessionService: SessionPackageService,
        private session: SessionStoreService,
        private scheduleService: ScheduleService,
        public loginService: LoginService,
        private activeroute: ActivatedRoute,
        private configProviderService: BingoConfigProviderService,
        private user: UserService,
        private loadingIndicatorService: LoadingIndicatorService,
    ) {
        this.featuresConfig = this.configProviderService.provideFeaturesConfig();
    }

    ngOnInit() {
        if (localStorage.getItem('config')) {
            this.clientConfig = JSON.parse(localStorage.getItem('config')!);
        }
        if (this.featuresConfig.packagesfilterMap) {
            this.packageFilterItems = Object.values(this.featuresConfig.packagesfilterMap);
        }
        this.deepLinkedPackageId = this.activeroute.snapshot.queryParamMap.get('packageId');
        this.content = this.clientConfig?.packageGlobalMessages;
        this.getPackageData();
        //call getSessionData when the user logs in package bingo page
        this.user.events.pipe(filter((e) => e instanceof UserLoginEvent)).subscribe(() => {
            this.getPackageData();
        });
    }
    getSessionListData(gameData: any) {
        this.sessionService.getSessionList('package_bingo', gameData).subscribe(
            (response: any) => {
                try {
                    this.packagesLoading = false;
                    if (response?.bingoPackageList.result) {
                        if (response.bingoPackageList.result.package_list?.package_list) {
                            let packageDataList = response.bingoPackageList.result.package_list.package_list.packages;
                            this.sessionService.packageIdOrderedList = response.packageIdOrderedList || [];
                            const packageIds = Object.keys(packageDataList);
                            let packageItems = Object.values(packageDataList);
                            if (packageItems && packageItems.length > 0) {
                                for (let val = 0; val < packageItems.length; val++) {
                                    this.sessionService.onPackageInfoFromSessionList(packageIds[val], packageItems[val]);
                                }
                                this.packagesAvailable = true;
                                this.sessionService.packageTracking(
                                    'navigation',
                                    'top navigation',
                                    'not Aplicable',
                                    'not Aplicable',
                                    'package_bingo',
                                );
                                if (this.loginService.packageBingoforcedData?.id && this.packages && this.packages.length) {
                                    const packageItem: any = this.packages.find((item) => item.id == this.loginService.packageBingoforcedData.id);
                                    if (this.loginService.packageBingoforcedData.triggerType == 'moreInfo' && packageItem) {
                                        packageItem?.moreInfoClicked();
                                    } else if (this.loginService.packageBingoforcedData.triggerType == 'buyNow' && packageItem) {
                                        packageItem?.buyNowClicked();
                                    }
                                }
                            } else {
                                this.packagesAvailable = false;
                            }
                        }
                    }
                    this._loadingIndicator.done();
                } catch (error) {
                    this._loadingIndicator.done();
                    this.packagesLoading = false;
                }
            },
            () => {
                this._loadingIndicator.done();
                this.packagesLoading = false;
            },
        );
    }

    // checkForPurchasedPackage() {
    //     this.sessionService.isPurchaseObsevable.subscribe((response: any) => {
    //         if (response) {
    //             this.packageItems.forEach((element: any) => {
    //                 if (element.id == response.Id) {
    //                     if (response.isPurchase) element.staus_of_package = 'purchase';
    //                     else element.staus_of_package = 'purchased';
    //                     // this.getSessionData();
    //                 }
    //             });
    //         }
    //     });
    // }
    getPackageData() {
        this._loadingIndicator = this.loadingIndicatorService.start();
        const gameData: any = this.session.get('ScheduleFeed');
        if (gameData) {
            this.getSessionListData(gameData);
        } else {
            this.scheduleService.getGameData((response: any) => {
                if (response) {
                    this.getSessionListData(response);
                }
            });
        }
    }

    filterOptionClicked(filterItem: any) {
        if (filterItem == this.selectedFilterItem) {
            return;
        } else {
            this.selectedFilterItem = filterItem;
            this.sessionService.filterPackages(filterItem);
        }
    }

    get filteredPackageItems() {
        let filteredItems: any[] = [];
        let packageKeys = this.sessionService.packageIdOrderedList;
        for (let key of packageKeys) {
            let item = this.sessionService.packageInfo[key];
            if (item && !item.hideItem) {
                item.sort_weight_value = item.sort_weight_value || 1000;
                filteredItems.push(item);
            }
        }
        const sortedItems = this.sessionService.sortPackages(filteredItems);
        return sortedItems;
    }

    clearFilter() {
        this.selectedFilterItem = {};
        this.sessionService.unhideAllPackages();
    }

    ngOnDestroy() {
        this.sessionService.clearPackageInfo();
    }
}
